// Port of api/fuel/app/classes/filter/search/games/rules/query/version_size_footprint.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'version_size_footprint',
	field: function() { return '(v.game_version_storage_width * v.game_version_storage_length * v.game_version_storage_depth)' }
})
